import React from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { HeartIcon } from 'lucide-react';
import { NumberCard } from '../components/NumberCard';
import { getNumber } from '../data/numbers';
import { useLibrary } from '../contexts/LibraryContext';
const ease = [0.23, 1, 0.32, 1] as const;
export function Favorites() {
  const {
    favorites
  } = useLibrary();
  const entries = favorites.map(id => getNumber(id));
  const saved = entries.filter(Boolean).length;
  return <motion.div initial={{
    opacity: 0,
    y: 8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.26,
    ease
  }} data-id="element-95" data-mp="169zs36fihxya">
      <h1 className="text-[26px] font-light leading-tight tracking-tight text-white" data-id="element-96" data-mp="rkkaoh1vf4v9">
        Your saved numbers
      </h1>
      <p className="mt-2 max-w-[290px] text-[13.5px] leading-relaxed text-lav-dim" data-id="element-97" data-mp="1kakai1hilrr9">
        Keep the numbers that feel meaningful to you close.
      </p>

      {saved === 0 ? <div className="glass mt-8 flex flex-col items-center rounded-4xl px-6 py-12 text-center" data-id="element-98" data-mp="942sdv7wausf">
          <span aria-hidden="true" className="relative flex h-16 w-16 items-center justify-center rounded-full border border-aura/25" data-id="element-99" data-mp="44zyn6xd8azr">
            <span className="aura-pulse absolute inset-0 rounded-full" style={{
          background: 'radial-gradient(circle, rgba(139,92,246,0.32) 0%, rgba(5,6,15,0) 70%)'
        }} data-id="element-100" data-mp="iv76kspqybm7" />
            <HeartIcon className="relative h-6 w-6 text-aura-bright" strokeWidth={1.5} data-id="element-101" data-mp="rwnfsx4ts7ou" />
          </span>
          <p className="mt-5 text-[17px] font-semibold tracking-tight text-white" data-id="element-102" data-mp="mxu0r09w48mk">No numbers saved yet</p>
          <p className="mt-2 max-w-[240px] text-[13.5px] leading-relaxed text-lav-dim" data-id="element-103" data-mp="wtnnfchbpii2">
            Save an angel number to find it here later.
          </p>
          <Link to="/explore" className="mt-6 rounded-2xl border border-aura/45 bg-aura/[0.14] px-6 py-3.5 text-[14px] font-semibold text-white transition-[background-color,box-shadow] duration-200 ease-smooth hover:bg-aura/20 hover:shadow-[0_0_28px_-8px_rgba(139,92,246,0.9)] focus:outline-none focus-visible:ring-2 focus-visible:ring-aura-bright/70" data-id="element-104" data-mp="33kwml926s3gh">
            Explore numbers
          </Link>
        </div> : <section className="mt-7" data-id="element-105" data-mp="639jjdvbicsg">
          <p className="mb-3 text-[12px] font-medium uppercase tracking-[0.16em] text-lav-dim" data-id="element-106" data-mp="64cb7o0gsj9f">
            {saved} saved
          </p>
          <div className="flex flex-col gap-2.5" data-id="element-107" data-mp="b0tbfgkxuo2v">
            <AnimatePresence initial={false} data-id="element-108" data-mp="f36699y5d1kv">
              {entries.map(entry => entry && <motion.div key={entry.id} layout initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            scale: 0.97
          }} transition={{
            duration: 0.22,
            ease
          }} data-id="element-109" data-mp="jx0wyxc66gtg">
                      <NumberCard entry={entry} variant="row" showSave data-id="element-110" data-mp="2jasjefk1qkgr" />
                    </motion.div>)}
            </AnimatePresence>
          </div>
          <Link to="/explore" className="mt-6 flex items-center justify-center rounded-2xl border border-white/10 bg-white/[0.04] px-5 py-3.5 text-[13.5px] font-semibold text-lav transition-[background-color,border-color,color] duration-200 ease-smooth hover:border-aura/45 hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-aura-bright/70" data-id="element-111" data-mp="29bthdftsdn2q">
            Find more numbers
          </Link>
        </section>}
    </motion.div>;
}